// Imports for external libraries go here.
import { FC } from 'react';
import { TermsOfUseProps } from './TermsOfUse.types';
import { StyledTermsOfUse } from './TermsOfUse.styles';
import { sanitize } from '../../../../modules/utils/common';

// Use named rather than default exports.
export const TermsOfUse: FC<TermsOfUseProps> = ({ ppv5RTE }) => {
  const termsOfUse = sanitize(ppv5RTE ?? '');

  return (
    <StyledTermsOfUse
      data-testid="ppv5-TermsOfUse"
      data-component-name="o-ppv5-TermsOfUse"
      className="my-4 py-4 container"
    >
      {termsOfUse && (
        <p
          data-testid="terms-of-use"
          dangerouslySetInnerHTML={{
            __html: termsOfUse,
          }}
        ></p>
      )}
    </StyledTermsOfUse>
  );
};
